export const menuDefaultFilters = {
  state: {
    value: "true",
    title: "Active",
    label: "Active",
  },
};
